// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "76e626383f6f32c63935" + "." + "main" + ".css";
};